

const StarIcon = ({ size = 14, fill = "#E7BA22", starFill = "white" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="14" height="14" rx="7" fill={fill} />
    <path
      d="M6.5736 3.27532C6.75313 2.90046 7.26183 2.91608 7.4264 3.27532L8.41386 5.35264L10.5982 5.68064C10.9872 5.74312 11.1369 6.24293 10.8526 6.53969L9.28163 8.14844L9.65567 10.4132C9.71552 10.8193 9.29659 11.1317 8.95248 10.9442L7.00748 9.86653L5.04752 10.9442C4.70341 11.1317 4.28448 10.8193 4.34433 10.4132L4.71837 8.14844L3.14741 6.53969C2.86314 6.24293 3.01275 5.74312 3.40175 5.68064L5.6011 5.35264L6.5736 3.27532Z"
      fill={starFill}
    />
  </svg>
);

export default StarIcon;
